import React from 'react';

import cx from '@travel/ui/utils/classnames';

import styles from './messageBox.module.scss';

type Props = {
  className?: string;
  icon?: React.ReactElement;
  message: React.ReactElement;
};

function MessageBox(props: Props) {
  const { className, icon, message, ...rest } = props;
  return (
    <div className={cx(styles.wrapper, className)} {...rest}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <div className={styles.message}>{message}</div>
    </div>
  );
}

export default MessageBox;
